<template>
  <div class="mltags" v-if="tags.length > 0">
    <div class="tags-toggle">
      <span class="glyphicon glyphicon-tags"> </span>
    </div>
    <div class="mldata-details">
      <p v-if="typeof record.mldata.relevance !=='undefined' && record.mldata.relevance !== null">
        <strong>Relevance</strong>:
          {{ record.mldata.relevance | round }}
          <span v-if="record.mldata.keyword">
            ({{record.mldata.keyword}})
          </span>
      </p>
      <p v-if="typeof record.mldata.consistency !=='undefined' && record.mldata.consistency !== null">
        <strong>Consistency</strong>: {{ record.mldata.consistency | round }}
      </p>
      <table class="mltags-table">
        <thead>
          <tr>
            <th>Category</th>
            <th>Weight</th>
            <th>#&nbsp;Frames</th>
            <th>Accuracy</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tag, mIndex) in manualTags" :key="tag.category + mIndex">
            <td>{{ tag.category }}</td>
            <td v-if="tag.weight">{{ Math.round(tag.weight * 10000000) / 1000 }}</td>
            <td v-else></td>
            <td>{{ tag.frames }}</td>
            <td>{{ tag.accuracy | round }}</td>
          </tr>
          <tr v-for="(tag, mlIndex) in mlTags" :key="mlIndex">
            <td>{{ tag.category }}</td>
            <td v-if="tag.weight">{{ Math.round(tag.weight * 10000000) / 1000 }}</td>
            <td v-else></td>
            <td>{{ tag.frames }}</td>
            <td>{{ tag.accuracy | round }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
export default {
  data () {
    return {
      engines: {
        aws: 'aws', // AWS recognition tags
        kul: 'kul', // KUL recognition tags
        man: 'man', // manual tags
      }
    }
  },
  props: [
    'record',
  ],
  filters: {
    round (val) {
      // round the value to 2 decimal places
      return Math.round(val * 100) / 100
    }
  },
  computed: {
    tags () {
      return this.record.mltags
    },
    mlTags () {
      // sort record tags according to their accuracy multiplied by
      // the amount of frames they were detected in.
      return this.tags
        .filter(tag => tag.engine !== this.engines.man)
        .sort((a, b) => {
          const accDiff = b.accuracy - a.accuracy
          if (accDiff !== 0) return accDiff
          else return b.frames - a.frames
        }
      )
    },
    manualTags () {
      return this.tags
        .filter(tag => tag.engine === this.engines.man)
        .sort((a, b) => a.category <= b.category ? -1 : 1)
    },
  }
}
</script>



// WEBPACK FOOTER //
// MLTags.vue?1fc02886